(() => {
    const SELECTOR = '[data-pdp-acc]';
    const prefersReducedMotion = () =>
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const ease = 'cubic-bezier(.2,.8,.2,1)';
    const OPEN_MS = 380;
    const CLOSE_MS = 320;

    const getPanel = (details) => details.querySelector('.pdp-acc__panel');
    const getSummary = (details) => details.querySelector('summary');

    const cancelAnimations = (el) => el.getAnimations?.().forEach((a) => a.cancel());

    const animateHeight = (panel, from, to, ms, done) => {
        cancelAnimations(panel);
        panel.style.height = `${from}px`;
        panel.offsetHeight; // reflow

        const anim = panel.animate(
            [{ height: `${from}px` }, { height: `${to}px` }],
            { duration: ms, easing: ease }
        );

        anim.onfinish = () => {
            panel.style.height = to === 0 ? '0px' : '';
            done?.();
        };
    };

    const openPanel = (details) => {
        const panel = getPanel(details);
        if (!panel) return;

        if (prefersReducedMotion()) {
            panel.style.height = '';
            return;
        }

        panel.style.height = 'auto';
        const end = panel.getBoundingClientRect().height;

        animateHeight(panel, 0, end, OPEN_MS, () => {
            panel.style.height = '';
        });
    };

    const closePanel = (details, afterClose) => {
        const panel = getPanel(details);
        if (!panel) return;

        if (prefersReducedMotion()) {
            panel.style.height = '0px';
            afterClose?.();
            return;
        }

        panel.style.height = 'auto';
        const start = panel.getBoundingClientRect().height;

        animateHeight(panel, start, 0, CLOSE_MS, () => {
            afterClose?.();
        });
    };

    const initOne = (details) => {
        const panel = getPanel(details);
        const summary = getSummary(details);
        if (!panel || !summary) return;

        if (!details.open) panel.style.height = '0px';

        details.addEventListener('toggle', () => {
            if (details.open) openPanel(details);
        });

        summary.addEventListener('click', (e) => {
            if (!details.open) return;
            if (prefersReducedMotion()) return;

            e.preventDefault();

            closePanel(details, () => {
                details.removeAttribute('open');
            });
        });
    };

    const init = () => {
        document.querySelectorAll(SELECTOR).forEach(initOne);
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
